/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBitcoin: {
  name: 'bitcoin';
  data: string;
} = {
  name: 'bitcoin',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1a.5.5 0 0 0-1 0v.5H4a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h.5v.5a.5.5 0 0 0 1 0v-.5h2v.5a.5.5 0 0 0 1 0v-.5a4 4 0 0 0 1.779-7.584A3 3 0 0 0 8.5 1.5V1a.5.5 0 0 0-1 0v.5h-2V1Zm3 1.5h-4v4h4a2 2 0 1 0 0-4Zm0 5h-4v6h4a3 3 0 1 0 0-6Z" fill="currentColor"/></svg>`,
};
